<template>
  <v-app>
    <v-container>
      <v-card class="mx-auto" max-width="800">
        <!-- Header -->
        <v-card-title class="pa-4 info lighten-3 justify-center">
          <h3 class="text-h5 font-weight-bold black--text">
            Timeline Prenotazione
          </h3>
        </v-card-title>

        <!-- Timeline Content -->
        <v-card-text class="pa-0">
          <v-timeline align-top dense>
            <v-timeline-item
              v-for="(event, index) in events"
              :key="`event-${index}`"
              :color="index === 0 ? 'success' : 'info'"
              :small="index !== 0"
              fill-dot
            >
              <template v-slot:opposite>
                <span class="text-caption grey--text">
                  {{ formatDate(event.TS) }}
                </span>
              </template>

              <v-card :color="index === 0 ? 'success lighten-4' : 'info lighten-4'">
                <v-card-title class="py-2">
                  <v-chip 
                    :color="index === 0 ? 'success' : 'info'" 
                    dark 
                    small
                    class="mr-2"
                  >
                    #{{ index + 1 }}
                  </v-chip>
                  <strong>{{ formatDate(event.TS, true) }}</strong>
                </v-card-title>

                <v-card-text class="pt-0">
                  <v-simple-table dense>
                    <tbody>
                      <tr 
                        v-for="(value, key) in getEventData(event)" 
                        :key="`${index}-${key}`"
                      >
                        <td class="font-weight-medium field-label">
                          {{ getFieldLabel(key) }}
                        </td>
                        <td>
                          <span 
                            v-html="getFieldValue(index, key, value)"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-card-text>
              </v-card>
            </v-timeline-item>
          </v-timeline>
        </v-card-text>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
export default {
  name: 'TimelinePrenotazione',
  
  data() {
    return {
      // Field labels mapping
      fieldLabels: {
        active: 'Attivo',
        confirmed: 'Confermato', 
        date: 'Data',
        time: 'Ora',
        covers: 'Coperti',
        children: 'Bambini',
        wa: 'WhatsApp',
        firstName: 'Nome',
        lastName: 'Cognome',
        area: 'Area',
        tables: 'Tavoli',
        username: 'Utente'
      },

      // Events data
      events: [
        {
          active: 1,
          confirmed: 1,
          date: "2025-02-23",
          time: "20:00",
          covers: 4,
          children: 0,
          wa: "3421325211",
          firstName: "WalkIn",
          lastName: "",
          area: "Interno",
          TS: "2025-02-23 20:18:30",
          tables: "17-18",
          username: "web"
        },
        {
          active: 1,
          confirmed: 1,
          date: "2025-02-23",
          time: "21:00",
          covers: 4,
          children: 1,
          wa: "3421325211",
          firstName: "WalkIn",
          lastName: "",
          area: "Interno",
          TS: "2025-02-23 20:16:25",
          tables: "",
          username: "web"
        },
        {
          active: 1,
          confirmed: 1,
          date: "2025-02-23",
          time: "20:30",
          covers: 3,
          children: 1,
          wa: "3421325211",
          firstName: "WalkIn",
          lastName: "",
          area: "Interno",
          TS: "2025-02-23 20:15:42",
          tables: "",
          username: "web"
        },
        {
          active: 0,
          confirmed: 1,
          date: "2025-02-23",
          time: "19:15",
          covers: 5,
          children: 0,
          wa: "",
          firstName: "Paola",
          lastName: "",
          area: "Interno",
          TS: "2025-02-23 19:32:13",
          tables: "",
          username: "web"
        },
        {
          active: 1,
          confirmed: 1,
          date: "2025-02-23",
          time: "20:00",
          covers: 4,
          children: 0,
          wa: "",
          firstName: "Ginevra",
          lastName: "Ivaldi",
          area: "Interno",
          TS: "2025-02-23 12:37:51",
          tables: "",
          username: "web"
        }
      ]
    }
  },

  computed: {
    /**
     * Processed events with additional metadata
     */
    processedEvents() {
      return this.events.map((event, index) => ({
        ...event,
        index,
        isLatest: index === 0
      }))
    }
  },

  methods: {
    /**
     * Get event data excluding timestamp
     * @param {Object} event - The event object
     * @returns {Object} Event data without TS field
     */
    getEventData(event) {
      const { TS, ...eventData } = event
      return eventData
    },

    /**
     * Get human-readable field label
     * @param {string} key - The field key
     * @returns {string} Human-readable label
     */
    getFieldLabel(key) {
      return this.fieldLabels[key] || key
    },

    /**
     * Get formatted field value with change detection
     * @param {number} currentIndex - Current event index
     * @param {string} key - Field key
     * @param {*} currentValue - Current field value
     * @returns {string} Formatted HTML string
     */
    getFieldValue(currentIndex, key, currentValue) {
      // If not the latest event, compare with previous
      if (currentIndex < this.events.length - 1) {
        const previousEvent = this.events[currentIndex + 1]
        const previousValue = previousEvent[key]
        
        // Show change if values are different
        if (currentValue !== previousValue) {
          return `<span class="red--text font-weight-bold">
            ${this.formatValue(previousValue)} → ${this.formatValue(currentValue)}
          </span>`
        }
      }
      
      return `<span class="black--text">${this.formatValue(currentValue)}</span>`
    },

    /**
     * Format individual values for display
     * @param {*} value - The value to format
     * @returns {string} Formatted value
     */
    formatValue(value) {
      if (value === null || value === undefined) return '-'
      if (value === '') return 'Vuoto'
      if (typeof value === 'boolean') return value ? 'Sì' : 'No'
      if (typeof value === 'number') return value.toString()
      return value
    },

    /**
     * Format date with Italian locale
     * @param {string} dateString - ISO date string
     * @param {boolean} includeTime - Whether to include time
     * @returns {string} Formatted date string
     */
    formatDate(dateString, includeTime = false) {
      const date = new Date(dateString)
      
      const dateOptions = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      }
      
      const timeOptions = {
        hour: '2-digit',
        minute: '2-digit'
      }

      const formattedDate = date.toLocaleDateString('it-IT', dateOptions)
      
      if (includeTime) {
        const formattedTime = date.toLocaleTimeString('it-IT', timeOptions)
        return `${formattedDate} - ${formattedTime}`
      }
      
      return formattedDate
    }
  }
}
</script>

<style scoped>
.v-timeline-item__body {
  padding-left: 16px !important;
}

.v-card__title {
  word-break: break-word;
}

.field-label {
  width: 140px;
  min-width: 140px;
}

.v-simple-table td {
  padding: 8px 16px !important;
  vertical-align: top;
}

.text-caption {
  font-size: 0.75rem !important;
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .field-label {
    width: 120px;
    min-width: 120px;
    font-size: 0.875rem;
  }
  
  .v-card__title {
    padding: 12px 16px !important;
  }
  
  .v-simple-table td {
    padding: 6px 12px !important;
  }
}
</style>